module.exports = "//a.spikex.com/sigma/frontend-ssr-web-user-center/_next/static/images/avatar-default-a6844a173f8522380dba78821273073e.png";